
export default function initializingSmartScript(link) {
    //Initializing Smart Script arguments
    const oneLinkURL = link;
    const mediaSource = {keys:["utm_source"],defaultValue:"site"};
    const campaign = {keys:["oid","utm_campaign"],defaultValue:"organic_site"};
    const click_id = {paramKey:"click_id",keys:["clickid"],defaultValue:"null"};
    const ad = {keys:["utm_content"],defaultValue:"null"};
    const channel = {keys:["utm_promo"],defaultValue:"null"};
    const utm_medium = {paramKey:"utm_medium",keys:["utm_medium"],defaultValue:"null"};
    const afSub1 = {keys:["a_aid"],defaultValue:"null"};
    const chan = {paramKey:"chan",keys:["chan"],defaultValue:"null"};
    const utm_term = {paramKey:"utm_term",keys:["utm_term"],defaultValue:"null"};
    const afSub3 = {keys:["data1"],defaultValue:"null"};
    const afSub2 = {keys:["a_bid"],defaultValue:"null"};
    const afSub4 = {keys:["data2"],defaultValue:"null"};
    const custom_ss_ui = {paramKey:"af_ss_ui",defaultValue:"true"};

    //Call the function after embedding the code through a global parameter on the window object called window.AF_SMART_SCRIPT.
    //Onelink URL is generated.
    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
        oneLinkURL: oneLinkURL,
        afParameters: {
            mediaSource: mediaSource,
            campaign: campaign,
            afCustom: [
                click_id,
                utm_medium,
                chan,
                utm_term,
                custom_ss_ui
            ],
            ad: ad,
            channel: channel,
            afSub1: afSub1,
            afSub3: afSub3,
            afSub2: afSub2,
            afSub4: afSub4
        }
    });

    return result;

    // If needed, you can download the script from: https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js
    // See an example of implementation and how to place the URL result behind a CTA on your website: https://appsflyersdk.github.io/appsflyer-onelink-smart-script/examples/utm_parameters.html?utm_campaign=mycmpn&utm_source=mysource
    // See an example of how to display a QR code: https://appsflyersdk.github.io/appsflyer-onelink-smart-script/examples/qr_code.html?inmedia=my_email&incmp=my_campaign
}



// WEBPACK FOOTER //
// ./_layout/js/initializingSmartScript.js